<template>
  <div class="detalis">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      警报详情
    </div>
    <el-form
      class="warningDetail"
      ref="dataForm"
      :model="dataForm"
      label-width="100px"
    >
      <el-form-item label="流量计名称:" prop="flowMeterName">
        <el-input v-model="dataForm.flowMeterName" disabled />
      </el-form-item>
      <el-form-item label="创建时间:" prop="createTime">
        <el-input v-model="dataForm.createTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次流量更新时间：{{ dataForm.lastFlowTime }}</p>
      <el-form-item label="流量更新时间:" prop="flowTime">
        <el-input v-model="dataForm.flowTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次流量值：{{ dataForm.lastFlowValue }}</p>
      <el-form-item label="流量值:" prop="flowValue">
        <el-input v-model="dataForm.flowValue" disabled />
      </el-form-item>
      <p class="tipsValue">上次压力更新时间：{{ dataForm.lastPressTime }}</p>
      <el-form-item label="压力更新时间:" prop="pressTime">
        <el-input v-model="dataForm.pressTime" disabled />
      </el-form-item>
      <p class="tipsValue">上次压力值：{{ dataForm.lastPressValue }}</p>
      <el-form-item label="压力值:" prop="pressValue">
        <el-input v-model="dataForm.pressValue" disabled />
      </el-form-item>
      <el-form-item label="电力更新时间:" prop="electricTime">
        <el-input v-model="dataForm.electricTime" disabled />
      </el-form-item>
      <el-form-item label="电力状态:" prop="status">
        <el-select v-model="dataForm.status" disabled>
          <el-option
            v-for="item in statusOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="警报描述:" prop="description">
        <el-input v-model="dataForm.description" type="textarea" rows="8" disabled />
      </el-form-item>

      <el-table
              :data="pressList"
              border
              lazy
              style="width: 100%;margin: 0 0 40px;"
      >
        <el-table-column
                prop="time"
                header-align="center"
                align="center"
                fixed="left"
                label="压力时间"
        />
        <el-table-column
                prop="value"
                header-align="center"
                align="center"
                label="压力值"
        />
      </el-table>
      <el-table
              :data="flowList"
              border
              lazy
              style="width: 100%;margin: 0 0 40px;"
      >
        <el-table-column
                prop="time"
                header-align="center"
                align="center"
                fixed="left"
                label="流量时间"
        />
        <el-table-column
                prop="value"
                header-align="center"
                align="center"
                label="流量值"
        />
      </el-table>
    </el-form>
    <div class="btnList" :style="{paddingBottom: (isiPhoneX == true ? '35px' : '')}">
      <el-button @click="makeSure" type="primary" v-if="!dataForm.isConfirm">确认警报</el-button>
      <el-button type="info" disabled v-else>已确认警报</el-button>
    </div>
    <el-dialog
      title="是否确认收到警报？"
      :visible.sync="visible"
      class="warnDialog"
    >
      <el-form ref="warnForm" :model="warnForm" label-width="100px">
        <el-form-item prop="remark" label="信息备注:">
          <el-input v-model="warnForm.remark" type="textarea" rows="6" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
        <el-button type="primary" @click="makeSureComfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      popstateLock: 0,//是否监听物理返回键
      visible: false,
      isiPhoneX: false,
      id: '',
      warnForm: {
        remark: null
      },
      dataForm: {
        createTime: null,  // 创建时间
        description: null,  // 警报描述
        electricTime: null, // 电力更新时间
        equipmentId: 0, // 流量计id
        flowLowerLimit: null, //  流量下限值
        flowMeterName: null,  //  调整流量计名称
        flowTime: null, //  流量更新时间
        flowUpperLimit: null, //  流量上限值
        flowValue: null,  //  流量值
        id: 0,  //  警报id
        isConfirm: null,
        isFlowAlarm: 0, // 是否流量报警
        isOutageAlarm: 0, // 是否断电报警
        isPressAlarm: 0,  // 是否压力报警
        name: null, // 流量计名称
        pressLowerLimit: null,  // 压力下限值
        pressTime: null,  // 压力更新时间
        pressUpperLimit: null,  // 压力上限值
        pressValue: null, // 压力值
        status: 1, //  电力状态 0备用电池，1通电
        type: 1, // 类型：1调度中心爬取，2丹灶数据，3纯手抄
        lastFlowTime: null, // 上次流量更新时间
        lastFlowValue: null,  // 上次流量值
        lastPressTime: null, // 上次压力更新时间
        lastPressValue: null  // 上次压力值
      },
      pressList: [], // 压力列表
      flowList: [], // 流量列表
      statusOptions: [
        {id: 0, name: "备用电池"},
        {id: 1, name: "通电"}
      ],
      orderDetails: {}, // 工单详情
      assetsType: '', // 资产类型
      reload: '', // 是否更新数据
      dialogVisible: false,
      loading: true
    }
  },
  // 解决keep-alive的冲突
  beforeRouteEnter (to, from, next) {
    if (from.path === '/record' || from.path === '/remindrecord') {
      next(vm => {
        // 通过 `vm` 访问组件实例
        vm.getDetailsById()
      })
    } else {
      next()
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted () {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    },
    // 查询数据
    getDetailsById () {
      // 先拿id
      this.id = this.$route.query.id
      // 然后拿工单详情
      this.$http.httpGet(`/app/tbAlarmRecord/inf/`+ this.id).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.dataForm = res.tbAlarmRecord;
          this.pressList = res.tbAlarmRecord.pressList;
          this.flowList = res.tbAlarmRecord.flowList;
          this.flowList.map(row => row.time = row.time.substr(0, 16));
          this.pressList.map(row => row.time = row.time.substr(0, 16));
        } else {
          // this.$message.error(res.msg)
          this.$alert('获取报警信息出错, 原因:' + res.msg, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              window.history.back(-1)
            }
          });
        }
      })
    },
    // 确认收到警报
    makeSure() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["warnForm"].resetFields();
      })
    },
    // 提交警报
    makeSureComfirm() {
      this.$http.httpPost('/app/appTbAlarmRecordConfirm/confirm', {
        "userId": parseInt(sessionStorage.getItem("userId")),
        "isConfirm": 1,
        "remark": this.warnForm.remark,
        "alarmRecordId": this.dataForm.id
      }).then(res => {
        if (res.msg === 'success' && res.code === 0) {
          this.visible = false;
          this.getDetailsById()
        }
      })
    },
    // 判断是否iPhone X
    isIPhoneX(){
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height == 812 && screen.width == 375){
          //是iphoneX
          this.isiPhoneX = true;
          this.heightTop = '40px';
        }else{
          //不是iphoneX
          this.isiPhoneX = false;
          this.heightTop = '0px';
        }
      }
    }
  },
  created () {
    this.isIPhoneX();
    this.getDetailsById();
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/global.scss';
.detalis ::v-deep {
  background-color: #fff;
  padding: 60px 0 50px;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #409eff;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .warningDetail {
    position: relative;
    padding: 0 15px;
    .el-form-item {
      margin: 0 0 15px;
      position: relative;
      .el-form-item__label {
        font-size: 12px;
        width: 100px;
        float: left;
      }
      .el-form-item__content {
        width: calc(100% - 100px);
        .el-input, .el-select {
          width: 100%;
        }
      }
    }
    .tipsValue {
      font-size: 13px;
      line-height: 1.4;
      margin: 0 0 8px;
      font-weight: 600;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px 20px;
  color: #606266;
  font-size: 16px;
  word-break: break-all;
}
.el-message-box {
  width: 35rem;
}
.warnDialog ::v-deep {
  .el-dialog {
    width: calc(100% - 30px);
    max-width: 900px;
    margin: 10vh auto 0 !important;
    width: calc(100% - 30px);
    .el-dialog__header {
      padding: 15px;
      border-bottom: 1px #efefef solid;
    }
    .el-dialog__footer {
      padding: 15px;
      border-top: 1px #efefef solid;
    }
    .el-dialog__body {
      height: calc(80vh - 193px);
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
.btnList {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding: 10px 0;
  border-top: 1px #efefef solid;
  z-index: 999;
  .el-button {
    width: 100%;
  }
}
</style>
